var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V19H19V16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7198 12.7008L12.6959 16.7015C12.6908 16.7125 12.6797 16.7176 12.6737 16.7235C12.5262 16.8702 12.3351 16.9627 12.144 16.9898C12.1278 16.9898 12.1116 16.9949 12.0945 16.9949C12.0621 17 12.0288 17 11.9964 17L11.9034 16.9949C11.8872 16.9949 11.871 16.9898 11.8539 16.9898C11.6577 16.9627 11.4718 16.8702 11.3242 16.7235C11.3191 16.7184 11.308 16.7074 11.302 16.7015L7.27809 12.7008C7.09212 12.5159 7 12.2717 7 12.0274C7 11.7832 7.09298 11.5389 7.27809 11.354C7.64916 10.9851 8.2557 10.9851 8.63189 11.354L11.0503 13.7584L11.0528 3.94989C11.0528 3.42916 11.4845 3 12.0082 3C12.2701 3 12.5107 3.10856 12.6856 3.27648C12.8605 3.45034 12.9637 3.68357 12.9637 3.94989V13.7592L15.382 11.3549C15.7531 10.986 16.3597 10.986 16.7358 11.3549C17.0907 11.7298 17.0909 12.3319 16.7198 12.7008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0cf42de6200bba6c56228b2b1ecacc7e.svg";
export { ForwardRef as ReactComponent };